import cx from 'classnames';
import { Stack } from '../../../../components/stack/Stack';
import { TClassSummary } from '../../../../../types/utilityTypes';
import { TClassSelectViewOptions } from './types';
import { t } from 'i18next';
import { ClassIcon } from '../ClassIcon';
import { Avatar } from '../../../../components/avatar/Avatar';

export interface IClassOptionProps {
  cls: TClassSummary;
  viewOptions: Required<TClassSelectViewOptions>;
  context: 'menu' | 'value';
  iconSize?: number;
}

export const ClassOption = ({ cls, viewOptions, iconSize = 18 }: IClassOptionProps) => {
  return (
    <Stack alignItems="center" gap={8}>
      <Avatar size={'auto'} border style={{ flexShrink: 0 }}>
        <ClassIcon class={cls.slug} size={iconSize} style={{ display: 'flex' }} />
      </Avatar>

      <span
        className={cx({
          [`class-color--${cls.slug}`]: viewOptions.classColor
        })}
      >
        {t(`game:classes.${cls.slug}.name`)}
      </span>
    </Stack>
  );
};
